import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, AppBar, Toolbar, Typography, Box, Container, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import Ondara from '../../assets/ondara_inv.png';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';

import { useAuth } from '../../context/AuthContext';

const navLinks = [
  { label: 'Resumen', path: '/dashboard' },
  { label: 'Operaciones en curso', path: '/dashboard/investments-active' },
  { label: 'Operaciones cerradas', path: '/dashboard/investments-closed' },
  { label: 'Información fiscal', path: '/dashboard/tax' },
  { label: 'Oportunidades', path: '/dashboard/opportunities' },
];

function Header() {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  if (!userData?.userData) return null;

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavClick = (path) => {
    navigate(path);
    handleMenuClose();
  };

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: '#000000', color: '#ffffff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Container disableGutters maxWidth='xl'>
          <Toolbar disableGutters sx={{ px: 2, minHeight: 64 }}>
            <Box sx={{ flex: '0 0 auto', mr: 4, cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
              <img src={Ondara} alt="Ondara Capital" height="36" />
            </Box>

            {!isMobile && (
              <Box sx={{ flex: 1, display: 'flex', gap: 1 }}>
                {navLinks.map((link) => (
                  <Button
                    key={link.path}
                    onClick={() => navigate(link.path)}
                    disabled={link.disabled}
                    sx={{
                      color: '#fff',
                      fontWeight: location.pathname === link.path ? 700 : 400,
                      borderBottom: location.pathname === link.path ? '2px solid #fff' : '2px solid transparent',
                      borderRadius: 0,
                      textTransform: 'none',
                      px: 1.5,
                      '&:hover': { borderBottom: '2px solid rgba(255,255,255,0.5)' },
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}

            <Box sx={{ flex: '0 0 auto', display: 'flex', gap: 1, ml: isMobile ? 'auto' : 2 }}>
              <Button variant="contained" onClick={() => setOpen(true)} sx={{ minWidth: 40, px: 1 }}>
                <PersonIcon />
              </Button>
              <Button variant="contained" href="/logout" sx={{ minWidth: 40, px: 1 }}>
                <LogoutIcon />
              </Button>
              {isMobile && (
                <IconButton
                  onClick={handleMenuOpen}
                  sx={{ color: '#fff' }}
                  aria-controls={openMenu ? 'mobile-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMenu ? 'true' : undefined}
                >
                  <MenuIcon />
                </IconButton>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Menu
        id="mobile-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#000',
              color: '#fff',
              mt: 1,
              minWidth: 200,
            },
          },
        }}
      >
        {navLinks.map((link) => (
          <MenuItem
            key={link.path}
            onClick={() => handleNavClick(link.path)}
            disabled={link.disabled}
            sx={{
              fontWeight: location.pathname === link.path ? 700 : 400,
              borderLeft: location.pathname === link.path ? '3px solid #fff' : '3px solid transparent',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
              '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' },
            }}
          >
            {link.label}
          </MenuItem>
        ))}
      </Menu>

      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Perfil de inversor
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <table className="pclp-investordata">
            <tbody>
              <tr><td>Nombre y apellidos:</td><td>{userData.userData.Name}</td></tr>
              <tr><td>Email:</td><td>{userData.userData.Email}</td></tr>
              <tr><td>Telefono:</td><td>{userData.userData.Telefono}</td></tr>
              <tr><td>DNI/CIF:</td><td>{userData.userData.DNI_CIF}</td></tr>
              <tr><td>Estado civil:</td><td>{userData.userData.Estadi_civil}</td></tr>
              <tr><td>Dirección:</td><td>{userData.userData.Direcccion_a_efectos_de_notificacion}</td></tr>
              <tr><td>IBAN cuenta bancaria:</td><td>{userData.userData.Num_Cuenta}</td></tr>
              <tr><td>Ocupación:</td><td>{userData.userData.Ocupacion}</td></tr>
              <tr><td>Empresa:</td><td>{userData.userData.Empresa}</td></tr>
              <tr><td>Apoderado de la empresa:</td><td>{userData.userData.Nombre_apoderado_empresa}</td></tr>
            </tbody>
          </table>
          <Typography align="center" sx={{ margin: 4 }}>
            Si algun dato no es correcto, por favor informa a <a href="mailto:contacto@ondara.group">contacto@ondara.group</a>
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Header;